import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle, ArrowRight } from "lucide-react";
import { Button } from "../../components/ui/button";

const Success = () => {
    return (
        <div className="min-h-screen bg-[#070710] flex items-center justify-center p-4">
            <div className="max-w-md w-full text-center space-y-8 animate-in fade-in zoom-in duration-500">
                <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-primary to-blue-600 rounded-full blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                    <div className="relative bg-[#070710] rounded-full p-4 inline-block">
                        <CheckCircle className="w-20 h-20 text-primary" />
                    </div>
                </div>

                <div className="space-y-4">
                    <h1 className="text-4xl font-bold text-white tracking-tight">
                        Payment Successful!
                    </h1>
                    <p className="text-gray-400 text-lg">
                        Thank you for your subscription. Your account has been upgraded, and your team can now enjoy all the premium features.
                    </p>
                </div>

                <div className="pt-8">
                    <Link to="/user">
                        <Button className="w-full bg-primary hover:bg-btnHover text-white py-6 text-lg group">
                            Go to Dashboard
                            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </Button>
                    </Link>
                </div>

                <div className="text-sm text-gray-500">
                    A receipt has been sent to your email address.
                </div>
            </div>
        </div>
    );
};

export default Success;
